<script setup lang="ts">
import { ref } from 'vue'
import QrcodeVue from 'qrcode.vue'
import type { Level, RenderAs } from 'qrcode.vue'

const { value } = defineProps({
  value: {
    type: String,
  },
})

const level = ref<Level>('M')
const renderAs = ref<RenderAs>('canvas')
const size = ref<number>(200)
</script>

<template>
  <qrcode-vue
    data-testid="qr-code"
    class="qr-code"
    :value="value"
    :level="level"
    :render-as="renderAs"
    :size="size" />
</template>

<style scoped></style>
